import { CONTACT } from "@/data/projects";

export default function Footer() {
  return (
    <footer className="border-t border-hairline bg-paper" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 py-14 sm:px-10">
        <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="font-serif text-3xl font-light text-ink">Rushikesh Patil</p>
            <p className="mt-2 text-[12px] font-medium uppercase tracking-[0.18em] text-fog">
              Hospitality Strategy · Investment · Commercial Analysis
            </p>
            <p className="mt-1 text-[12px] uppercase tracking-[0.18em] text-fog">{CONTACT.location}</p>
          </div>
          <nav className="flex flex-wrap items-center gap-x-8 gap-y-3" aria-label="Footer">
            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="text-[12px] font-semibold uppercase tracking-[0.18em] text-smoke transition-colors hover:text-ink">
              Email
            </a>
            <a href={CONTACT.linkedin} target="_blank" rel="noreferrer" data-testid="footer-linkedin" className="text-[12px] font-semibold uppercase tracking-[0.18em] text-smoke transition-colors hover:text-ink">
              LinkedIn
            </a>
            <a href={CONTACT.cv} download data-testid="footer-cv" className="text-[12px] font-semibold uppercase tracking-[0.18em] text-smoke transition-colors hover:text-ink">
              CV
            </a>
          </nav>
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-hairline pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-serif text-sm italic text-fog">Designed around hospitality, data and decisions.</p>
          <p className="text-[11px] uppercase tracking-[0.18em] text-fog">© {new Date().getFullYear()} Rushikesh Patil</p>
        </div>
      </div>
    </footer>
  );
}
